module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fJeRm"))).then(() => parcelRequire('9Lwss'));